import { isNullOrUndefinedOrEmptyStr } from '../../utilities/stringUtil';
import { USER_ROLES } from '../../utilities/constants';

/**
 * 検索用パラメータを作成
 * @param {object}param:検索パラメーター
 * @return {object}searchParam:API通信用検索パラメーター
 * */
const createSearchUserListByRole = param => {
  const searchParam = Object.create(null);
  searchParam.offset = param.offset;
  if (!isNullOrUndefinedOrEmptyStr(param.limit)) {
    searchParam.limit = Number(param.limit);
  }

  if (!isNullOrUndefinedOrEmptyStr(param.fullname)) {
    searchParam.fullname = String(param.fullname);
  }

  if (!isNullOrUndefinedOrEmptyStr(param.isPrimeUser)) {
    if (param.isPrimeUser === true) {
      if (!isNullOrUndefinedOrEmptyStr(param.company_branch_id)) {
        // 本社を選択している場合
        if (Number(param.company_branch_id) === -1) {
          searchParam.user_role_code = USER_ROLES.prime.id;
        } else {
          searchParam.company_branch_id = Number(param.company_branch_id);
        }
      }
    } else {
      if (!isNullOrUndefinedOrEmptyStr(param.partner_company_branch_id)) {
        // 本社を選択している場合
        searchParam.partner_company_branch_id = Number(
          param.partner_company_branch_id
        );
      }
      if (param.partner_company_branch_id === null) {
        searchParam.partner_company_branch_id = '';
      }
    }
  }

  if (!isNullOrUndefinedOrEmptyStr(param.block_flag)) {
    searchParam.block_flag = Number(param.block_flag);
  }

  if (!isNullOrUndefinedOrEmptyStr(param.company_id)) {
    searchParam.company_id = param.company_id;
  }

  if (!isNullOrUndefinedOrEmptyStr(param.user_role_code)) {
    searchParam.user_role_code = param.user_role_code;
  }

  return searchParam;
};

const UsersService = {
  createSearchUserListByRole,
};

export default UsersService;



// WEBPACK FOOTER //
// ./src/services/users/UsersService.js